const MAX_VALUES_FOR_SUBSTRING_MATCHING = 100

/**
 * For quick filters, we only want to allow sub-string matches when the value
 * is less than some arbitrary allowed value.
 */
export function FilterTypeForQuickFilterOfLength(
  length: number,
): 'containsIn' | 'in' {
  return length > MAX_VALUES_FOR_SUBSTRING_MATCHING ? 'in' : 'containsIn'
}
